import { render, staticRenderFns } from "./CampaignDeadlineEditModal.vue?vue&type=template&id=25fbb342&scoped=true&"
import script from "./CampaignDeadlineEditModal.vue?vue&type=script&lang=ts&"
export * from "./CampaignDeadlineEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignDeadlineEditModal.vue?vue&type=style&index=0&id=25fbb342&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fbb342",
  null
  
)

export default component.exports